import { createTheme } from "@nextui-org/react";

export const darkTheme = createTheme({
  type: "dark",
  theme:{
    colors:{
      background: "transparent",
    }
  }
});
